import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreFinderRegionComponent } from '../store-finder-region/store-finder-region.component';

@Component({
  selector: 'boels-store-finder',
  templateUrl: './store-finder.component.html',
  styleUrls: ['./store-finder.component.scss'],
  imports: [RouterModule, StoreFinderRegionComponent],
})
export class StoreFinderComponent {}
